// @flow

import React from 'react';
import { StyleWrapper, Overlay } from './desktop.styled';
import type { Nav } from '../../../types/apiRoute';
import ElementGenerator from './elementGenerator';

type Props = {
  nav: Nav,
};

const Desktop = ({ nav }: Props) => (
  <>
    <StyleWrapper>
      <nav>
        <ElementGenerator nav={nav} />
      </nav>
    </StyleWrapper>
    <Overlay className="overlay" />
  </>
);

export default Desktop;
